import type { review_status } from './api'

const amount_format = new Intl.NumberFormat('de-DE', {
  style: 'currency',
  currency: 'EUR',
})

/** Der Betrag kommt als String an und wird nur zur Anzeige umgewandelt. */
export function format_amount(amount: string): string {
  return amount_format.format(Number(amount))
}

export function is_outgoing(amount: string): boolean {
  return amount.startsWith('-')
}

export function format_date(iso_date: string): string {
  const [year, month, day] = iso_date.split('-')
  return `${day}.${month}.${year}`
}

export function format_timestamp(iso: string): string {
  return new Date(iso).toLocaleString('de-DE', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  })
}

export function format_bytes(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`
  if (bytes < 1024 * 1024) return `${Math.round(bytes / 1024)} kB`
  return `${(bytes / 1024 / 1024).toFixed(1)} MB`
}

export const status_label: Record<review_status, string> = {
  open: 'Offen',
  submitted: 'Eingereicht',
  accepted: 'Angenommen',
  rejected: 'Abgelehnt',
}
